export const FETCH_ENROLLMENT_INITIAL = "FETCH_ENROLLMENT_INITIAL";
export const FETCH_ENROLLMENT_SUCCESS = "FETCH_ENROLLMENT_SUCCESS";
export const FETCH_ENROLLMENT_FAILURE = "FETCH_ENROLLMENT_FAILURE";
